import { useState } from 'react'
import { Nav, Tab } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { openPopup } from "../../store/popupSlice"

export default function HealthcareExpertise() {

  const dispatch = useDispatch();

  const images = [
    './assets/home/health-expertise-img1.webp',
    './assets/home/health-expertise-img2.webp',
    './assets/home/health-expertise-img3.webp',
    './assets/home/health-expertise-img4.webp',
    './assets/home/health-expertise-img.webp',
    './assets/home/health-expertise-img6.webp',
    './assets/home/health-expertise-img7.webp',
    './assets/home/health-expertise-img8.webp',
    './assets/home/health-expertise-img9.webp',
    './assets/home/health-expertise-img10.webp',
  ];

  const [activeTab, setActiveTab] = useState(0);
  return (
    <>
      <section className="healthcare-expertise">
        <Tab.Container id="left-tabs-example" defaultActiveKey="0" onSelect={(selectedKey) => setActiveTab(selectedKey)}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="health-expertise-header">
                  <h2 className="heading center-heading">Healthcare <span className="gradiant-color">Technology Solutions</span></h2>
                  <p className="sub-heading">Providing advanced healthcare services to drive the industry toward digital transformation <br /> while ensuring systems remain secure, compliant, and reliable.</p>
                </div>
              </div>

              <div className='col-lg-4 col-md-4'>
                <div className="health-expertise-areas">
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="0">EHR Integration Services</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="1">HIPAA & Healthcare Compliance</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="2">Healthcare Product Engineering</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="3">Healthcare Cloud Solutions</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="4">Healthcare App Development</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="5">Healthcare IoT & Wearables</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="6">QA & Test Automation</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="7">Healthcare Data Science & BI</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="8">Healthcare Blockchain Solution</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="9">Hire Health Tech Experts</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </div>
              <div className='col-lg-8 col-md-8'>
                <Tab.Content>
                  <Tab.Pane eventKey="0">
                    <div className="health-expertise-content">
                      <h3 className="heading"><span className="gradiant-color">EHR Integration Services</span></h3>
                      <p>Transform your healthcare applications with seamless integration to major EHR systems, improving clinical efficiency and patient care.</p>
                      <ul>
                        <li>Cerner Integrations</li>
                        <li>Epic Integrations (App Orchard Program)</li>
                        <li>Redox Engine</li>
                        <li>FHIR</li>
                        <li>HL7</li>
                        <li>First Databank (FDB) Integrations</li>
                      </ul>
                      <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn more</Link>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="1">
                    <div className="health-expertise-content">
                      <h3 className="heading"><span className="gradiant-color">HIPAA & Healthcare Compliance</span></h3>
                      <p>Ensure full compliance with healthcare regulations and secure handling of patient health information (PHI) through our HIPAA-compliant app development services.</p>
                      <ul>
                        <li>Data Access/Security/Encryption (ePHI)</li>
                        <li>HIPAA and HITech Compliance</li>
                        <li>Secure Messaging</li>
                      </ul>
                      <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn more</Link>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="2">
                    <div className="health-expertise-content">
                      <h3 className="heading"><span className="gradiant-color">Healthcare Product Engineering</span></h3>
                      <p>From ideation to product launch, we design, build, and support scalable healthcare applications that meet enterprise standards, with a focus on innovation.</p>
                      <ul>
                        <li>Roadmap & Requirements</li>
                        <li>Rapid Prototyping & MVP Development</li>
                        <li>Legacy System Modernization</li>
                        <li>Dedicated Digital Health Startup Services</li>
                        <li>Micro Venture Partnerships</li>
                      </ul>
                      <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn more</Link>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="3">
                    <div className="health-expertise-content">
                      <h3 className="heading"><span className="gradiant-color">Healthcare Cloud Solutions</span></h3>
                      <p>Streamline your transition to the healthcare cloud with our expert services, including deployment, support, and management across AWS, Microsoft Azure, GCP, and more.</p>
                      <ul>
                        <li>Cloud Migration Services</li>
                        <li>Compliant Cloud Operations</li>
                        <li>Cloud Assessment</li>
                        <li>Managed Cloud Services</li>
                      </ul>
                      <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn more</Link>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="4">
                    <div className="health-expertise-content">
                      <h3 className="heading"><span className="gradiant-color">Healthcare App Development</span></h3>
                      <p>Leverage our expertise in developing secure, compliant healthcare apps that enhance mobility and streamline healthcare services.</p>
                      <ul>
                        <li>Healthcare App Consulting</li>
                        <li>App UI/UX Services</li>
                        <li>App Maintenance</li>
                        <li>App Backend Development</li>
                      </ul>
                      <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn more</Link>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="5">
                    <div className="health-expertise-content">
                      <h3 className="heading"><span className="gradiant-color">Healthcare IoT & Wearables</span></h3>
                      <p>Enhance patient outcomes through a connected healthcare ecosystem with our innovative IoT and wearable technology services.</p>
                      <ul>
                        <li>NFC-based IoT Solutions</li>
                        <li>Telehealth & Remote Patient Monitoring</li>
                        <li>Connected Medical Devices & Wearables</li>
                        <li>Virtual Assistance for Patients & Providers</li>
                        <li>IoT Medical Device Integration</li>
                        <li>Wearables App Development</li>
                        <li>Clinical Trials Support</li>
                      </ul>
                      <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn more</Link>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="6">
                    <div className="health-expertise-content">
                      <h3 className="heading"><span className="gradiant-color">QA and Test Automation</span></h3>
                      <p>Ensure the highest quality for your healthcare applications with comprehensive testing and automation services.</p>
                      <ul>
                        <li>Functional Testing</li>
                        <li>Usability Testing</li>
                        <li>Security & Compliance Testing</li>
                        <li>Performance Testing</li>
                        <li>Platform Testing</li>
                      </ul>
                      <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn more</Link>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="7">
                    <div className="health-expertise-content">
                      <h3 className="heading"><span className="gradiant-color">Healthcare Data Science and BI</span></h3>
                      <p>Harness the power of healthcare data to drive personalized care, smarter diagnostics, and improved patient outcomes.</p>
                      <ul>
                        <li>Patient Monitoring with Wearables Data</li>
                        <li>Smarter Diagnostics</li>
                        <li>Precision Medicine</li>
                        <li>Medical Image Analysis</li>
                        <li>Patient Data Management</li>
                      </ul>
                      <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn more</Link>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="8">
                    <div className="health-expertise-content">
                      <h3 className="heading"><span className="gradiant-color">Healthcare Blockchain Solution</span></h3>
                      <p>Unlock the potential of blockchain technology to create secure, transparent, and efficient healthcare products and services.</p>
                      <ul>
                        <li>Advisory Services & Programs</li>
                        <li>Strategic Blockchain Assessments</li>
                        <li>Healthcare Blockchain Consulting</li>
                        <li>Custom Healthcare Blockchain Solutions</li>
                        <li>Smart Contract Development</li>
                        <li>Blockchain Integration Services</li>
                      </ul>
                      <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn more</Link>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="9">
                    <div className="health-expertise-content">
                      <h3 className="heading"><span className="gradiant-color">Hire Health Tech Experts</span></h3>
                      <p>Access a team of experienced, HIPAA-certified healthcare software developers, skilled in the latest digital healthcare technologies.</p>
                      <ul>
                        <li>Hire SMART FHIR Consultant</li>
                        <li>Hire HIPAA Consultant</li>
                      </ul>
                      <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn more</Link>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>


            </div>
            <img
              src={images[activeTab]}
              loading='lazy'
              alt="health"
              className="img-responsive health-expertise-img wow animate__animated animate__zoomIn"
              data-wow-duration="1.2s"
              data-wow-delay="0.2s"
            />
          </div>
        </Tab.Container>
      </section>
    </>
  )
}
